module.exports = __webpack_public_path__ + "static/media/d17kz.07cd39a3.pdf";